module.exports = __webpack_public_path__ + "static/media/store.5fb1ee60.png";